import React, { useContext } from 'react';
import { isPlatform, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../state';
import { Action } from '../../types';

interface HeaderProps {
  title?: string;
}

interface MobileHeaderProps extends HeaderProps {
  backButtons?: React.ReactNode;
}

export const DesktopHeader: React.FC<HeaderProps> = () => {
  const { dispatch, user } = useContext(Context);
  const { t } = useTranslation('common');

  if (isPlatform('desktop')) {
    return (
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            Baby Kix
          </IonTitle>

          <IonButtons slot="end">
            {!user ?
              <IonButton onClick={() => dispatch({ type: Action.ToggleLoginModal, payload: { showLogin: true }})}>
                {t('login')}
              </IonButton>
              :
              <>
                <IonText class="ion-padding-horizontal">
                  {user.displayName}
                </IonText>
              </>
            }
          </IonButtons>
        </IonToolbar>
      </IonHeader>
    )
  }

  return <></>
};

export const MobileHeader: React.FC<MobileHeaderProps> = ({ title, backButtons }) => {
  const { dispatch, user } = useContext(Context);
  const { t } = useTranslation('common');

  if (isPlatform('mobile')) {
    return (
      <IonHeader>
        <IonToolbar color="light">
          {backButtons && backButtons}
          <IonTitle>{title}</IonTitle>
          <IonButtons slot="end">
            {!user ?
              <IonButton onClick={() => dispatch({ type: Action.ToggleLoginModal, payload: { showLogin: true } })}>
                {t('login')}
              </IonButton>
              :
              <>
                <IonText class="ion-padding-horizontal">
                  {user.displayName}
                </IonText>
              </>
            }
          </IonButtons>
        </IonToolbar>
      </IonHeader>
    );
  }

  return <></>;
}

export const MobileHeaderCondensed: React.FC<HeaderProps> = ({ title }) => {
  if (isPlatform('mobile')) {
    return (
      <IonHeader collapse="condense">
        <IonToolbar className="title" color="light">
          <IonTitle size="large">
            {title}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
    );
  }

  return <></>;
}
